import { useQuery } from "@tanstack/react-query";

export interface FieldOption {
  value: string;
  label: string;
}

const fetchSalesforceFields = async (
  objectName: string
): Promise<FieldOption[]> => {
  if (!objectName) {
    return [];
  }

  const response = await fetch(
    `/api/salesforce/describable-fields?object_name=${objectName}`
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage =
      errorData.error || `Failed to fetch Salesforce ${objectName} fields`;
    throw new Error(errorMessage);
  }

  const data = await response.json();
  return data.fields.map((field: { api_name: string; label: string }) => ({
    value: field.api_name,
    label: field.label,
  }));
};

export const salesforceFieldKeys = {
  all: ["salesforceFields"] as const,
  object: (objectName: string) =>
    [...salesforceFieldKeys.all, objectName] as const,
};

// El hook personalizado
export const useSalesforceFields = (objectName: string) => {
  return useQuery<FieldOption[], Error>({
    queryKey: salesforceFieldKeys.object(objectName),
    queryFn: () => fetchSalesforceFields(objectName),
    enabled: !!objectName,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
